import { defineMessages } from 'react-intl'

export default defineMessages({
  apply: {
    id: 'SpaceAnalyticsPage.Section.DateRangeFilters.Apply.Label',
    defaultMessage: 'Apply'
  },

  cancel: {
    id: 'SpaceAnalyticsPage.Section.DateRangeFilters.Cancel.Label',
    defaultMessage: 'Cancel'
  }
})
